import { useCallback } from 'react'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { getRetailerSearchUrl } from '@shared/constants/routes'
import { type SearchParams } from '@/features/shop/services/Search/types'
import { stringify } from '@/features/shared/utils/queryString'
import { useUserShoppingStore } from '@/features/shop/services/ShoppingStore/hooks'

type Args = {
  params?: SearchParams & { searchType?: 'typed' | 'autocomplete' }
  pathname?: string
}

export const useRouteToSearch = () => {
  const router = useSegwayRouter()
  const { data: shoppingStore } = useUserShoppingStore()

  const routeToSearch = useCallback(
    ({ params, pathname }: Args = {}) => {
      if (!pathname) {
        pathname = getRetailerSearchUrl(shoppingStore?.name)
      }
      const route = params ? `${pathname}?${stringify(params)}` : pathname
      return router.push(route, { shallow: true })
    },
    [router, shoppingStore?.name],
  )

  return { routeToSearch }
}
